import React from 'react';
import PaymentStatusBadge from './PaymentStatusBadge';

export default function AppointmentModalHeader({
  mode,
  appointment,
  effectivePaymentStatus,
  onClose,
  prefilledCustomer,
  t,
}) {
  return (
    <div className="">
      <div className="px-6 pt-4">
        <div className="flex items-center justify-between">
          <h2 className="text-xl font-semibold text-gray-900">
            {mode === 'edit' ? 'עריכת תור' : 'קביעת תור חדש'}
          </h2>
          <div className="flex items-center space-x-3">
            {mode === 'edit' && appointment && (
              <PaymentStatusBadge paymentStatus={effectivePaymentStatus} />
            )}
            <button onClick={onClose} className="text-gray-400 hover:text-gray-600">
              <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>
          </div>
        </div>
      </div>

      {prefilledCustomer && mode === 'add' && (
        <div className="mt-3 p-3 bg-green-50 border border-green-200 rounded-lg">
          <div className="flex items-center space-x-2">
            <span className="text-green-600 m-3">👤</span>
            <div>
              <p className="text-sm font-medium text-green-800">
                {t.bookingAppointmentFor} {prefilledCustomer.full_name}
              </p>
              <p className="text-xs text-green-600">{prefilledCustomer.phone}</p>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
